import { DispatchBoardQueueLoad, DispatchBoardQueueStatus } from "app/data/city-delivery/dispatch-board/models";
import React, { memo, useState } from "react";
import Button, { ButtonThemes } from "ui-components/button/button";
import { SetupDoor } from "./setup-door/setupDoor";
import { CloseDoor } from "./close-door/closeDoor";
import { DispatchManifest } from "./dispatch-manifest/dispatchManifest";

export interface CityDeliveryDispatchWorkflowActionsProps {
    dispatchLoad: DispatchBoardQueueLoad
}

const CityDeliveryDispatchWorkflowActions: React.FC<CityDeliveryDispatchWorkflowActionsProps> = memo((props) => {
    const [showAssignDoor, setShowAssignDoor] = useState(false);
    const [showCloseDoor, setShowCloseDoor] = useState(false);
    const [showDispatchManifest, setShowDispatchManifest] = useState(false);

    const getActionButton = (dispatchLoadStatus: DispatchBoardQueueStatus) => {
        if (dispatchLoadStatus === DispatchBoardQueueStatus.READY_TO_ASSIGN) {
            return <Button
                theme={ButtonThemes.blue}
                className="city-delivery-dispatch-workflow__actions__button"
                disabled={false}
                spinner={false}
                onClick={() => { setShowAssignDoor(true) }}
            >
                Assign to Door
            </Button>
        } else if (dispatchLoadStatus === DispatchBoardQueueStatus.LOADING) {
            return <Button
                theme={ButtonThemes.blue}
                className="city-delivery-dispatch-workflow__actions__button"
                disabled={true}
                spinner={false}
                onClick={() => { }}
                title="Load in Progress, please complete the loading to close the load"
            >
                Close Load & Create Manifest
            </Button>
        } else if (dispatchLoadStatus === DispatchBoardQueueStatus.READY_TO_CLOSE) {
            return <Button
                theme={ButtonThemes.blue}
                className="city-delivery-dispatch-workflow__actions__button"
                disabled={false}
                spinner={false}
                onClick={() => setShowCloseDoor(true)}
            >
                Close Load & Create Manifest
            </Button>
        } else if (dispatchLoadStatus === DispatchBoardQueueStatus.READY_TO_DISPATCH) {
            return <Button
                theme={ButtonThemes.blue}
                className="city-delivery-dispatch-workflow__actions__button"
                disabled={false}
                spinner={false}
                onClick={() => { setShowDispatchManifest(true) }}
            >
                Dispatch Manifest
            </Button>
        } else if (dispatchLoadStatus === DispatchBoardQueueStatus.DISPATCHED) {
            return <Button
                theme={ButtonThemes.blue}
                className="city-delivery-dispatch-workflow__actions__button"
                disabled={false}
                spinner={false}
                onClick={() => window.open("/manifest/manifests", "_blank", "noopener,noreferrer")}
            >
                Track Manifest
            </Button>
        }
    }

    const getActionSubText = (dispatchLoadStatus: DispatchBoardQueueStatus) => {
        if (dispatchLoadStatus === DispatchBoardQueueStatus.LOADING) {
            return <div className="city-delivery-dispatch-workflow__actions__subtext">
                Load in progress. Please complete loading to close the load and create a manifest.
            </div>
        } else if (dispatchLoadStatus === DispatchBoardQueueStatus.READY_TO_DISPATCH) {
            return <div className="city-delivery-dispatch-workflow__actions__subtext">
                Please complete the assignments (Driver, Trailer, etc) to proceed with dispatching the manifest.
            </div>
        }
    }
    return (
        <>
            <div className="city-delivery-dispatch-workflow__actions">
                {/* {getActions(props.dispatchLoadStatus)} */}
                {getActionButton(props.dispatchLoad.status)}
                {getActionSubText(props.dispatchLoad.status)}
            </div>
            {showAssignDoor && <SetupDoor
                show={showAssignDoor}
                onClose={() => setShowAssignDoor(false)}
                dispatchLoad={props.dispatchLoad}
            />}
            {showCloseDoor && <CloseDoor
                show={showCloseDoor}
                onClose={() => setShowCloseDoor(false)}
                dispatchLoad={props.dispatchLoad}
            />}
            {showDispatchManifest && <DispatchManifest
                show={showDispatchManifest}
                onClose={() => setShowDispatchManifest(false)}
                dispatchLoad={props.dispatchLoad}
            />}
        </>
    );
});

export default CityDeliveryDispatchWorkflowActions;
